import React from 'react';
export function Comparison() {
  const benefits = ['Care from perimenopause specialists', 'Quick, convenient telehealth', 'Personalized treatment plans', 'Exclusively bioidentical hormones', 'Direct home delivery', 'Unlimited follow-ups at no extra cost'];
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-34">
      <div className="max-w-[960px] mx-auto px-6" data-id="element-35">
        <p className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em] text-center" data-id="element-36">
          ORLA VS. TRADITIONAL
        </p>
        <h2 className="mt-4 font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-tight leading-[1.1] text-center" data-id="element-37">
          Care built for perimenopause.
        </h2>

        <div className="mt-12 md:mt-16 bg-orla-surface rounded-2xl shadow-lg overflow-hidden" data-id="element-38">
          <table className="w-full" data-id="element-39">
            <thead data-id="element-40">
              <tr className="bg-orla-sienna" data-id="element-41">
                <th className="py-5 px-6 text-left" data-id="element-42"></th>
                <th className="py-5 px-6 text-center" data-id="element-43">
                  <span className="font-display font-black text-[24px] text-orla-bone lowercase tracking-tight" data-id="element-44">
                    orla
                  </span>
                </th>
                <th className="py-5 px-6 text-center" data-id="element-45">
                  <span className="font-body font-semibold text-[15px] text-orla-bone" data-id="element-46">
                    Traditional Hormone Care
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47">
              {benefits.map((benefit, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-orla-surface' : 'bg-[#FAF5EC]'} data-id="element-48">
                  <td className="py-5 px-6 border-b border-orla-border" data-id="element-49">
                    <span className="font-body font-medium text-[16px] text-orla-ink" data-id="element-50">
                      {benefit}
                    </span>
                  </td>
                  <td className="py-5 px-6 border-b border-orla-border text-center" data-id="element-51">
                    <div className="flex justify-center" data-id="element-52">
                      <div className="w-6 h-6 rounded-full bg-orla-sage flex items-center justify-center" data-id="element-53">
                        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-54">
                          <polyline points="20 6 9 17 4 12" data-id="element-55" />
                        </svg>
                      </div>
                    </div>
                  </td>
                  <td className="py-5 px-6 border-b border-orla-border text-center" data-id="element-56">
                    <div className="flex justify-center" data-id="element-57">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#C4BBAE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-58">
                        <line x1="18" y1="6" x2="6" y2="18" data-id="element-59" />
                        <line x1="6" y1="6" x2="18" y2="18" data-id="element-60" />
                      </svg>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-8 font-display italic text-[14px] text-orla-muted text-center max-w-[640px] mx-auto" data-id="element-61">
          Compared based on typical US primary care and OB-GYN practices.
        </p>
      </div>
    </section>;
}